//source: http://www.honeylocust.com/javascript/randomizer.html

import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class RepeatableRandomGeneratorService {

    private initialSeed: number = 1;
    private seed: number = 1;

    setSeed(seed: number) {
        this.initialSeed = seed;
        this.seed = seed;
    }

    private getRandomNumber(min: number, max: number): number {
        this.seed = (this.seed * 9301 + 49297) % 233280;
        const rnd = this.seed / 233280;
        return min + rnd * (max - min);
    }

    randomizeArray<T>(list: T[]): T[] {
        this.seed = this.initialSeed;

        for (let index = 0; index < list.length; index++) {
            const element = list[index] as any;
            element._randomizeSortOrder = this.getRandomNumber(0, 1000);
        }

        const sortedList = _.sortBy(list, "_randomizeSortOrder");

        for (let index = 0; index < sortedList.length; index++) {
            const element = sortedList[index] as any;
            delete element._randomizeSortOrder;
        }

        return sortedList;
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/repeatable-random-generator.service.ts